// src/app/components/toast/toast.component.ts
import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastAction, ToastService } from 'src/utils/toast.service';
import { ToastType } from 'src/ui/types/toast-type.type';
import { ButtonsComponent } from 'src/ui/components/buttons/buttons.component';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, ButtonsComponent],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  toastService = inject(ToastService);
  get toasts() {
    return this.toastService.toasts();
  }

  removeToast(id: number) {
    this.toastService.removeToast(id);
  }

  runAction(id: number, action: ToastAction) {
    action.handler();
    this.removeToast(id);
  }

  closeAll() {
    this.toastService.clearAll();
  }

  getItemPositionClass(position: 'left' | 'right') {
    return position === 'left' ? 'justify-start' : 'justify-end';
  }

  getToastColor(type: ToastType) {
    const colors: Record<ToastType, string> = {
      success: 'bg-[#E1FCDE]',
      error: 'bg-[#FFD4D8]',
      warning: 'bg-[#FFF2D2]',
      info: 'bg-[#E0EDFF]',
      default: 'bg-[#F6F8FB]',
    };
    return colors[type] || colors['default'];
  }
}
